import { render, staticRenderFns } from "./FormularioCadastro.vue?vue&type=template&id=2b397f30&scoped=true&"
import script from "./FormularioCadastro.vue?vue&type=script&lang=js&"
export * from "./FormularioCadastro.vue?vue&type=script&lang=js&"
import style0 from "./FormularioCadastro.vue?vue&type=style&index=0&id=2b397f30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b397f30",
  null
  
)

export default component.exports